'use client'

import { useSlugnifier } from '@Server/app/utils/slugnifier'

export default function Page() {
  const { last } = useSlugnifier()
  return <section>default: {last || ' page'}</section>
}
